/*
 * @Author: along longwang6@163.com
 * @Date: 2025-07-10 11:40:15
 * @LastEditors: along longwang6@163.com
 * @LastEditTime: 2025-07-11 14:20:45
 * @FilePath: /ehr-web/src/components/TableEllipsis/index.tsx
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import React, { useRef, useEffect, useState } from 'react';
import { Tooltip } from '@arco-design/web-react';

interface IProps {
  text?: string;
  maxWidth?: number | string;
  style?: React.CSSProperties;
}

const TableEllipsis = React.memo((props: IProps) => {
  const { text, maxWidth = '100%', style } = props;
  const textRef = useRef<HTMLSpanElement>(null);
  const [isOverflow, setIsOverflow] = useState(false);

  useEffect(() => {
    const checkOverflow = () => {
      if (textRef.current) {
        const element = textRef.current;
        const isTextOverflow = element.scrollWidth > element.clientWidth;
        setIsOverflow(isTextOverflow);
      }
    };

    checkOverflow();
    // 监听窗口大小变化，重新检查
    window.addEventListener('resize', checkOverflow);
    return () => window.removeEventListener('resize', checkOverflow);
  }, [text, maxWidth]);

  const content = (
    <span
      ref={textRef}
      className={'text-ellipsis'}
      style={{
        display: 'inline-block',
        verticalAlign: 'middle',
        maxWidth: maxWidth,
        wordBreak: 'break-word',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        ...style,
      }}
    >
      {text}
    </span>
  );

  if (!isOverflow) {
    return content;
  }

  return (
    <Tooltip
      content={<span style={{ whiteSpace: 'pre-line' }}>{text}</span>}
      mini
      position={'top'}
      getPopupContainer={() => document.body}
    >
      {content}
    </Tooltip>
  );
});

export default TableEllipsis;
